import { gql } from '@apollo/client'

export const ADD_USERS_TO_ZONE = gql`
  mutation AddUsersToZone($input: UpdateZoneInput!) {
    addUsersToZone(input: $input) {
      success
    }
  }
`
